module.exports = __webpack_public_path__ + "img/2025-11-17d_3.ed4884a3.jpg";